module.exports = __webpack_public_path__ + "img/paint-strip-white-down.4980c6a.png";